// Entry point for the build script in your package.json
import '@hotwired/turbo-rails'
import './controllers'
import 'trix'
import '@rails/actiontext'
import * as ActiveStorage from '@rails/activestorage'
import * as bootstrap from 'bootstrap'

window.bootstrap = bootstrap
ActiveStorage.start()

// SECURITY: Disable file attachments in Trix editors.
// Prevents uploads via drag & drop, paste, or the attach button. File uploads
// create storage/cost concerns and potential security risks.
// NOTE: this is a UI deterrent, not an auth boundary — it does NOT block
// programmatic attachments (new Trix.Attachment()), which bypass the
// trix-file-accept event. Server-side blob authorization is the real control,
// owed by the first step that persists attachments.
document.addEventListener('trix-file-accept', (event) => {
  event.preventDefault()
})
